import { map, has, omitBy, isEmpty, isNil, isUndefined } from "lodash";
import moment from "moment";
import { OrgType } from "../../../types/customer-form.types";
import { Day } from "../../../types/common.types";

const response = (data: any) => {
  const contactFormatter = () => {
    let contactObj = {};

    contactObj = {
      ...contactObj,
      contactPerson: data.contact.fullName || null,
      adminEmailAddress: data.contact.email || null,
    };

    if (!isEmpty(data.contact.phones)) {
      data.contact.phones.map((phone) => {
        if (phone.type === "MOBILE") {
          contactObj = {
            ...contactObj,
            adminContactNo: {
              dialCode: phone.countryCode,
              number: phone.number,
            },
          };
        }
        if (phone.type === "OFFICE") {
          contactObj = {
            ...contactObj,
            officeContactNo: {
              dialCode: phone.countryCode,
              number: phone.number,
            },
          };
        }
      });
    }
    if (!isEmpty(data.primaryPhone)) {
      const primaryPhoneField =
        data.customerType === OrgType.COMPANY ? "contactNo" : "mobileNo";
      contactObj = {
        ...contactObj,
        [primaryPhoneField]: {
          dialCode: data.primaryPhone.countryCode,
          number: data.primaryPhone.number,
        },
      };
    }
    return contactObj;
  };

  return omitBy(
    {
      _id: data._id,
      customerName: !isNil(data.name) ? data.name : undefined,
      orgType: data.orgType,
      emailAddress: !isNil(data.primaryEmail) ? data.primaryEmail : undefined,
      street1: data.primaryAddress.street1 || null,
      street2: data.primaryAddress.street2 || null,
      city: data.primaryAddress.city || null,
      cityCode: data.primaryAddress.cityCode || null,
      state: data.primaryAddress.state || null,
      stateCode: data.primaryAddress.stateCode || null,
      postcode: data.primaryAddress.postcode || null,
      country: data.primaryAddress.country || null,
      businessRegistrationNumber: data.regNo || null,
      companyWebsite: !isEmpty(data.website) ? data.website : undefined,
      file: !isEmpty(data.image) ? data.image[0] : undefined,
      code: data.code,
      locationID: data.locationID || undefined,
      approvalStatus: data?.approvalInfo?.approvalStatus || undefined,
      handlingInstructions: data?.handlingInstructions || undefined,
      tempDeleteInfo: !isEmpty(data.tempDeleteInfo)
        ? data.tempDeleteInfo
        : undefined,
      parentOrgID: data.parentID || "",
      customerType: data.customerType || null,
      prefix: data.prefix || undefined,
      workingHours: data.workingHours || null,
      parcelTypes: data?.customerOrderTypes,
      allowPickupAll: data?.allowPickupAll,
      ...contactFormatter(),
    },
    isNil,
  );
};

export default response;
